<div class="">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">إدارة الاشتراكات</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #search (keyup)="($event)" class="form-control transparent" placeholder="بحث بواسطة الاسم أو الرقم الجامعي للمشترك " aria-label="Recipient's username" aria-describedby="basic-addon2">
            <i class="fa fa-times-circle pointer left" *ngIf="search.value.length>0" (click)="removeSearch()"></i>

          </div>
        </div>
      </div>
      <div class=" ml-auto">
        <span class="border rounded-circle p-2 mr-2">{{students.length}}</span>
        <button type="button" class="btn btn-outline-secondary mr-2   dashed-button" data-toggle="modal" data-target="#myModal"  (click)="changeEditMode()" >+ إضافة مشترك </button>
        <button type="button" class="btn btn-outline-secondary mr-2  dashed-button" data-toggle="modal" data-target="#semster"  >
          <span>
            <img src="../../assets/images/icons/cogSmall.svg"/>
          </span>
          تعين الفصل الدراسي
        </button>
        <!-- <button type="button" (click)="excelFile()"  class="btn btn-outline-secondary  dashed-button"   >+ إضافة ملف معلومات الطلبة </button> -->
        <input (change)="handleFile($event)" type="file" id="file-excel"  style="display:none"/>


      </div>

    </div>
  </div>
  <div class="row" *ngIf="loader">
    <div class="col-md-12">
      <div class="text-center">
        <div class="loader"></div>
      </div>
    </div>
  </div>

  <div class="row" >
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <table class="table no-border">

            <tbody>
            <tr *ngFor="let row of students|search: 'name' : search.value| paginate: { itemsPerPage: 10, currentPage: p }">
              <th scope="row"  class="no-border" width="75%">
                <div class="media align-items-center">
                  <a href="javascript:void(0)" class=" rounded-circle mr-3">
                    <ngx-avatar *ngIf="!row.profile_photo" name="{{row.name}}"></ngx-avatar>

                    <img  *ngIf="row.profile_photo" [src]="row.profile_photo?row.profile_photo:'assets/images/profile-square.jpg'" class="avatar-person"/>

                  </a>
                  <div class="" >
                    <span class="mb-0 text-sm">{{row.name}}</span>
                  </div>
                </div>
              </th>
              <td class="no-border">
                <div class="d-flex flex-row align-items-center" >
                  <div class="mr-2  py-2"  >
                    <button class="btn background-blue-g radius-16 w-194"  (click)="activeAccount(true,row._id)"  *ngIf="!row.active" >  تشغيل الخدمة</button>
                    <button class="btn background-red radius-16 w-194" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(row)"    *ngIf="row.active" >  ايقاف الخدمة</button>

                  </div>

                  <div class=""  >
                    <div class="dropdown">
                      <i class="fa fas fa-ellipsis-v text-black-50 pointer" data-toggle="dropdown" aria-expanded="false"></i>

                      <div class="dropdown-menu">
                        <a class="dropdown-item text-black-50 border-bottom" data-toggle="modal" data-target="#myTrip" (click)="getStudentTrip(row._id,'الرحلات المجدولة')">الرحلات المجدولة للمشترك</a>
                        <a class="dropdown-item text-black-50 border-bottom" data-toggle="modal" data-target="#myTrip" (click)="getStudentTrip(row._id,'الرحلات السابقة')">رحلات المشترك السابقة</a>
<!--                        <a class="dropdown-item text-black-50 border-bottom" href="#">بيانات تسجيل الدخول</a>-->
                        <a class="dropdown-item text-black-50 border-bottom"  data-toggle="modal" data-target="#myModal" (click)="getStudent(row._id)" > تعديل بيانات المشترك</a>
                        <a class="dropdown-item text-black-50 border-bottom"  data-toggle="modal" data-target="#assigneTrip" (click)="selectedRow(row)"  >تعين خط</a>
                        <a class="dropdown-item text-black-50 red" data-toggle="modal" data-target="#removeModal" (click)="selectedRow(row)" > حذف الاشتراك</a>
                      </div>
                    </div>

                  </div>

                </div>

              </td>

            </tr>
            </tbody>
          </table>

        </div>
      </div>
      <a data-toggle="modal" id="myTripOpenModal" data-target="#myTrip" style="visibility: hidden"></a>

      <div class="row">
        <div class="col-md-12">
          <pagination-controls [previousLabel]="'السابق'" [nextLabel]="'التالي'" (pageChange)="p = $event"></pagination-controls>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="myModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{editMode?"تعديل":"إضافة"}}   مشترك </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <p>ادخل البيانات المطلوبة لإضافة مشترك جديد:</p>
        <form [formGroup]="data">
          <div class="row">
            <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12  text-center">
              <img (click)="openFile()"  alt="User Pic" [src]="profileImg" id="profile-image" class="radius-50 img-circle img-responsive">

              <input type="file" (change)="changeImage($event)" accept="image/*" id="file"  style="display:none"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>اسم الطالب</label>

              <input type="text" formControlName="name" placeholder="اسم الطالب" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label> كلمة المرور</label>

              <input type="text" formControlName="password" placeholder="كلمة المرور" class="form-control">
            </div>
            <div class="col-md-6">
              <label>رمز التشغيل</label>

              <input type="text" formControlName="sis_code" placeholder="رمز التشغيل" class="form-control">
            </div>

          </div>
          <div class="row">
            <div class="col-md-6">
              <label>الرقم الجامعي</label>

              <input type="text" formControlName="student_id" placeholder="الرقم الجامعي" class="form-control">
            </div>
            <div class="col-md-6">
              <label>الجوال </label>

              <div class="input-group flex-nowrap">

                <input type="text" style="border-top-left-radius: unset !important;
    border-bottom-left-radius: unset !important;" class="form-control" placeholder="الجوال  " formControlName="phone" aria-label="Username" aria-describedby="addon-wrapping">
                <div class="input-group-prepend">
                  <span style="    border-bottom-left-radius: 16px;
    border-top-left-radius: 16px;
" class="input-group-text" id="addon-wrapping">+962</span>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>الفصل الدراسي</label>
              <select class="form-control" formControlName="semester" placeholder="الفصل الدراسي">
                <option value="" disabled selected>اختر الفصل الدراسي</option>
                <option *ngFor="let row of semsters" [value]="row._id">{{row.name}}</option>
              </select>
              
            </div>
          </div>

<!--          <div class="row">-->

<!--            <div class="col-md-12">-->
<!--              <select class="form-control gray" formControlName="license_type" >-->
<!--                <option class="gray" value="" disabled selected>اختر خط نقل الطالب</option>-->
<!--                <option value="1">1</option>-->
<!--                <option value="2">2</option>-->
<!--                <option value="3">3</option>-->
<!--              </select>-->
<!--            </div>-->

<!--          </div>-->

        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal" [disabled]="!data.valid"  style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5" (click)="editMode?edit():add()" >
                {{editMode?"تعديل":"إضافة"}}  مشترك</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="semster" tabindex='-1' role="dialog">
  <div class="modal-dialog modal-lg" >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">  تعين الفصل الدراسي </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <form [formGroup]="semster">
         <div class="row">
           <div class="col-md-6">
             <p class="trip-text">يرجى تعبئة البيانات التالية:  </p>
           </div>
           <div class="col-md-6 text-right">
             <button (click)="addSemster()" type="button" class="btn btn-outline-secondary mr-2  w-194 dashed-button"   >+ إضافة فصل </button>

           </div>
         </div>

          <div class="row" formArrayName="semster">
            <div class="col-md-12">
              <div class="">

                <div class="">
                  <div class="row" *ngFor="let itemrow of semster['controls']['semster']['controls']; let i=index"
                       [formGroupName]="i">

                    <div class="col-md-3">
                      <label>الفصل الدراسي</label>
                      <input type="text"  formControlName="name" placeholder="الفصل الدراسي" class="form-control">

                    </div>
                    <div class="col-md-4">
                      <label class="text-left">بداية الفصل</label>
                      <input type="date" formControlName="start" class="form-control"/>
                    </div>
                    <div class="col-md-4">
                      <label>نهاية الفصل</label>
                      <input type="date" formControlName="end" class="form-control"/>

                    </div>
                    <div class="col-md-1">
                      <i class="fa fa-minus-circle red pointer" style="font-size: 12px" *ngIf="semster.controls.semster.controls.length >0" (click)="deleteSemster(i)"></i>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal" style="width:280px" (click)="saveSemester()" [disabled]="!semster.valid" class="btn radius-16  background-blue-g pr-5 pl-5">حفظ</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">إيقاف  الاشتراك</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="col-md-6 container text-center">
            <p class="text-black ">
              هل أنت متأكد من رغبتك في إيقاف اشتراك الطالب ({{rowSelected['name']}}) ، سيتم منع الطالب من الوصول إلى حسابه والاستفادة من خدمات التطبيق
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="activeAccount(false,rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="removeModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف الاشتراك</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class=" container text-center">
            <p class="text-black ">
              هل أنت متأكد من رغبتك في حذف اشتراك الطالب ({{rowSelected['name']}}) ، سيتم منع الطالب من الوصول إلى حسابه والاستفادة من خدمات التطبيق وحذف جميع بياناته
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="deleteAccount(rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="myTrip"  tabindex='-1'role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{title}}</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal" id="mytripModal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="card mb-2" *ngFor="let travel of studentTrip">

          <div class="row">
            <div class="col-md-12">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb" style="background-color:white">
                  <li class="breadcrumb-item no-line ml-2 "><img src="../../assets/images/icons/home.svg"/></li>
                  <li class="breadcrumb-item no-line" > {{travel.trip_id['travel_start_name']}}   </li>
                  <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                  <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/gps.svg"> </li>
                  <li class="breadcrumb-item no-line" > {{travel.trip_id['travel_end_name']}} </li>
                  <li class="ml-auto" >

                    <div class="d-flex flex-row">
                      <div>
                        <span class="badge pr-2 pl-2 py-2  radius-8  bg-white border badge-light primary-color">{{travel.trip_id.way=='go'?'ذهاب':'عودة'}}</span>

                      </div>

                    </div>


                  </li>
                  <li class="ml-auto" >

                    <div class="d-flex flex-row">
                      <div>
                        <i  data-toggle="modal" data-target="#deleteAsignTravelModal" (click)="selectedTravel(travel)"  class="fa pointer border-red red  fa-trash circle"></i>

                      </div>

                    </div>


                  </li>

                </ol>

              </nav>
            </div>
          </div>
          <div class="row ml-3">
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <div class="py1">
                  <span>نقطة التوقف</span>
                </div>
                <div class="py1">
                  <span>                      <img src="../../assets/images/icons/home.svg" class="mr-2" width="20">
                     {{travel.pickup_point.label}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <div class="py1">
                  <span>وقت الجولة</span>
                </div>
                <div class="py1">
                  <span><img src="../../assets/images/icons/time.svg" class="mr-2"/>{{travel.pickup_point.time}}</span>

                </div>
              </div>
            </div>
          </div>

        </div>
<div *ngIf="studentTrip.length==0">
  <span>لا يوجد رحلات لهذا الطالب</span>
</div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="assigneTrip" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">تعيين خط </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-icons">
                <i class="fa fa-search icon">
                </i>
                <input type="text" #search2  (keyup)="($event)" class="form-control transparent" placeholder="بحث " aria-label="Recipient's username" aria-describedby="basic-addon2">
              </div>
            </div>
          </div>
        </div>
        <table class="table no-border">

          <tbody>

          <tr *ngFor="let row of trips|search: 'name' : search2.value;let i=index">

            <th scope="row"  class="no-border" width="75%">
              <div class="media align-items-center">
                <div class="" >
                  <span class="mb-0 text-sm">{{row.travel_start_name}} -> {{row.travel_end_name}} ({{row.way=="go"?
                    'ذهاب':'عودة'}})</span>
                </div>
              </div>
            </th>
            <td class="no-border text-right">

              <div class="custom-radios">
                <div>
                  <input type="checkbox" (click)="assignToTrip(row._id,assignTripData.includes(row._id))"  [checked]="assignTripData.includes(row._id) " id="color-1{{i*2}}"  class=" " name="hmead{{i}}" value="color-1">
                  <label for="color-1{{i*2}}">
      <span class="background-blue-g">
        <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg" alt="Checked Icon" />
      </span>
                  </label>
                </div>
              </div>
            </td>

          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" (click)="AsignTrip()"   style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5" data-dismiss="modal" >حفظ الإضافات</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="deleteAsignTravelModal" tabindex='-1'  role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content modal-raduis    radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف السائق</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class=" container text-center">
            <p class="text-black ">
              هل ترغب بالفعل بحذف  ({{selectedTravelData?selectedTravelData['trip_id']?selectedTravelData['trip_id']['travel_start_name']:''?selectedTravelData['trip_id']['travel_start_name']:'':''}} ) من الرحلات المجدولة لطالب ؟
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5"  data-dismiss="modal" (click)="removeAssignTravel(selectedTravelData['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
